import React from "react";
import { Card, Avatar } from "antd";
import Mapa from "./Mapa";
import logo from "../../images/png/avatar-black.png";

const { Meta } = Card;

const MapCard = props => (
  <Card style={{ width: "100hu" }} cover={<Mapa />}>
    <Meta
      avatar={<Avatar src={logo} />}
      title="Bombero Ossa #1010, Oficina 800, a pasos Metro U de Chile"
      description="Santiago, Chile."
    />
  </Card>
);

export default MapCard;
